import { h as i } from "./index811.mjs";
import { o as m } from "./index833.mjs";
import "./index747.mjs";
import "./index762.mjs";
import { __exports as v } from "./index765.mjs";
import { __exports as y } from "./index753.mjs";
var s = i, P = m, c = y, w = v, u = function(t, e, p) {
  for (var a = P(e), n = w.f, f = c.f, o = 0; o < a.length; o++) {
    var r = a[o];
    !s(t, r) && !(p && s(p, r)) && n(t, r, f(e, r));
  }
};
export {
  u as c
};
